<template>
    <svg width="42" height="28" viewBox="0 0 42 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3_1761)">
            <path d="M38 2V11.0797C38 13.1417 36.7341 14.9923 34.8122 15.7397L8.81222 25.8508C5.53454 27.1255 2 24.7076 2 21.1908V14" stroke="currentColor" stroke-width="2"/>
            <rect y="12" width="4" height="4" rx="2" fill="currentColor"/>
            <rect x="36" y="1" width="4" height="4" rx="2" fill="currentColor"/>
        </g>
        <defs>
            <clipPath id="clip0_3_1761">
                <rect width="42" height="28" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'SVGHanger',
};
</script>

<style scoped lang="scss">

</style>
